import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { Field, reduxForm } from 'redux-form';
import { FormRadio, ModalConfirmHealth, ModalPreexistence, ModalExamples } from '.';
import validate from '../helpers/dpsFormValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { env } from '../env';

const exampleData: Record<string, any> = {
  "Cáncer (Declarar NO si pasaron 5 años o más desde la finalización del tratamiento radical sin recaída)": [
    "Cualquier tipo de quiste o tumor benigno o maligno en cualquier localización o grado",
    "Leucemias",
    "Linfomas",
    "Mieloma"
  ],
  "Enfermedades al corazón o circulatorias": [
    "Enfermedad coronaria (infarto, pre-infarto, angina, angioplastias, cirugía By-pass)",
    "Insuficiencia cardiaca",
    "Arritmias",
    "Hipertensión Arterial",
    "Valvulopatías",
    "Miocardiopatías",
    "Hipertensión pulmonar",
    "Aneurismas o disecciones arteriales",
    "Tromboembolismo",
    "Varices",
    "Enfermedad reumática",
    "Soplos"
  ],
  "Enfermedades respiratorias o broncopulmonares": [
    "Asma",
    "Enfisema",
    "EPOC (Enfermedad pulmonar obstructiva Crónica)",
    "Fibrosis pulmonar",
    "Apnea del sueño",
    "Neumotórax",
    "Tuberculosis"
  ],
  "Enfermedades del sistema locomotor, huesos, articulaciones, columna (cualquier segmento), reumatológicas.": [
    "Hernias",
    "Artrosis y Enfermedades Reumatológicas",
    "Artritis Reumatoide",
    "Lupus",
    "Distrofias musculares",
    "Fibromialgia"
  ],
  "Enfermedad al sistema digestivo, hígado, vesícula y del páncreas": [
    "Hemorragia digestiva de cualquier causa",
    "Ulcera digestivas",
    "Reflujo",
    "Daño hepático crónico (hepatitis crónica, cirrosis hepática)",
    "Colitis ulcerosa",
    "Enfermedad de Crohn",
    "Diverticulitis",
    "Pólipos",
    "Hemorroides",
    "Pancreatitis",
    "Hernias",
    "Cálculos"
  ],
  "Enfermedad del riñon, uretra, vejiga, testículo, próstata, útero, mamas, trompas o genitales": [
    "Infecciones urinarias a repetición, Litiasis renal",
    "Prostatitis",
    "Hiperplasia Prostática",
    "Nefropatías",
    "Insuficiencia renal en cualquier estado",
    "Pielonefritis",
    "Nefritis",
    "Cálculos renales",
    "Nefrectomía riñones poliquísticos",
    "Insuficiencia renal"
  ],
  "Enfermedad del sistema nervioso central y/o periférico": [
    "Epilepsia",
    "Meningitis",
    "Mareos o vértigos",
    "Desmayos",
    "Convulsiones",
    "Cefaleas o jaqueca",
    "Trastornos del habla",
    "Parálisis",
    "Neuropatías",
    "Esclerosis múltiple",
    "Parkinson",
    "Ataque o infarto cerebral (Accidente vascular encefálico)",
    "Demencia",
    "Secuelas de traumatismo encefalocraneano",
    "Encefalopatías"
  ],
  "Enfermedad de la sangre": [
    "Anemias",
    "Hemofilia",
    "Trastornos de la coagulación",
    "Aplasia medular"
  ],
  "Enfermedades psicológicas o psquiátricas": [
    "Trastorno del ánimo/humor",
    "Depresión",
    "Trastorno bipolar",
    "Esquizofrenia",
    "Alzheimer",
    "Dependencia a sustancias psicoactivas (alcohol, drogas)",
    "Trastornos neuróticos",
    "Trastornos de la personalidad",
    "Crisis de pánico",
    "Trastornos de ansiedad",
    "Psicopatías",
    "Trastornos de personalidad o adaptación",
    "Déficit atencional"
  ],
  "Enfermedades de los ojos, oídos, boca, nariz, o garganta": [
    "Miopía",
    "Astigmatismo",
    "Presbicia",
    "Hipermetropía",
    "Estrabismo",
    "Cataratas",
    "Ceguera",
    "Glaucoma",
    "Retinopatía",
    "Hipoacusia",
    "Sordera",
    "Otitis crónica",
    "Vértigo",
    "Rinitis",
    "Desviación de tabique",
    "Pólipos"
  ],
  "Otros": [
    "Cirrosis Hepática y/o Biliar",
    "Diabetes Mellitus",
    "Insuficiencia Renal Crónica",
    "Lupus Eritematoso Sistémico",
    "Obesidad Mórbida (IMC mayor a 40)",
    "Trasplante de Órganos"
  ],
};

interface IDpsFormProps {
  handleSubmit: () => void;
  previousPage: () => void;
}

export function DpsForm(props: IDpsFormProps) {
  const { handleSubmit, previousPage } = props;
  const [openModal, setOpenModal] = useState(false);
  const [currentTitle, setCurrentTitle] = useState("");
  const [currentModalData, setCurrentModalData] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openModalExample, setOpenModalExample] = useState(false);
  const [dps, setDps] = useState(null);
  const [error, setError] = useState(false);
  const toggleModal = (state: boolean) => (_: any) => setOpenModal(state);
  const setErrorState = (error: boolean) => (_: any) => setError(error);
  const changeDps = ({ target: { value } }: any) => {
    setDps(JSON.parse(value));
    setErrorState(false)(1);
    toggleUserInteractionDps(JSON.parse(value));
  };
  const submit = () => {
    if (dps === null)
      setErrorState(true)(1);
    else
      (dps ? setOpenConfirmModal(true) : setOpenModal(true));
  };
  const toggleCurrentData = (data: any) => (_: any) => setCurrentModalData(data);
  const toggleCurrentTitle = (title: string) => (_: any) => setCurrentTitle(title);
  const toggleConfirmModal = (state: boolean) => (_: any) => setOpenConfirmModal(state);
  const toggleModalExample = (state: boolean) => (_: any) => setOpenModalExample(state);
  const toggleModalExampleWithData = (title: string) => (_: any) => {
    toggleModalExample(true)(1);
    toggleCurrentTitle(title)(1);
    toggleCurrentData(exampleData[title])(1);
  };

  const toggleUserInteractionDps = (value: any) => {
    ReactGA.event('user_interaction', {
      "action": !value ? "con-enfermedades": "sin-enfermedades",
      "location": "paso-dps",
      "flow": "salud-complementario"
    });
  }

  const toggleUserInteractionConfirmHealth = () => {
    ReactGA.event('user_interaction', {
      "action": "acepta-t-y-c",
      "location": "paso-dps",
      "flow": "salud-complementario"
    });
    handleSubmit()
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvDPS',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/dps',
        title: 'Seguro Salud Complementario',
        user_id: sessionStorage.getItem('userId'),
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-dps'
      });
    }
  }, []);

  return (
    <>
      <form noValidate={true}>
        <div className="row justify-content-center flex-column mb-70">
          <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto">
            <div className="wizard-card--title">
              <h3 className='text-center wizard-card--title'>Declaración Personal de Salud (DPS)</h3>
              <p className="text-bold m-0">En tu grupo familiar ¿Alguien ha tenido o tiene alguna de estas enfermedades?</p>
              <p className="m-0">Considera también aquellas que se encuentran en tratamiento o en estudio.</p>
              <Field
                name="dpsDeclaration"
                options={[
                  {
                    id: 'cleanDPS',
                    text: 'No, ninguna de ellas',
                    value: 'true',
                  },
                  {
                    id: 'dirtyDPS',
                    text: 'Si, una o más de las enfermedades mencionadas abajo',
                    value: 'false',
                  },
                ]}
                error="Es necesario marcar una de las dos opciones para continuar."
                activateError={error}
                component={FormRadio}
                onChange={changeDps}
              />
            </div>
          </div>
          <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto">
            {Object.keys(exampleData).map(key => 
              <div key={key} className="info-box-custom w-100 d-flex justify-content-start align-content-center flex-column">
                <span className="px-14">{key}</span>
                <span className="span-button cursor-pointer w-100 d-flex align-content-center" onClick={toggleModalExampleWithData(key)}>
                  Ver ejemplos <i className="material-icons">chevron_right</i>
                </span>
              </div>
            )}
          </div>
        </div>
        <footer className="fixed-footer-form emit-steps">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-sm-8 col-md-7 col-lg-6 pdy-16 d-flex justify-content-between align-content-center align-items-center">
                <button
                  className="btn white back-to-matrix col-4 d-flex justify-content-center align-content-center align-items-center"
                  type="button"
                  onClick={previousPage}
                >
                  <i className="material-icons">chevron_left</i>
                </button>
                <button 
                  className="btn primary go-to-contact-info col-8"
                  onClick={submit}
                  type="button"
                >
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </footer>
      </form>
      <ModalPreexistence open={openModal} toggle={toggleModal} />
      <ModalConfirmHealth open={openConfirmModal} toggle={toggleConfirmModal} submit={toggleUserInteractionConfirmHealth} />
      <ModalExamples open={openModalExample} toggle={toggleModalExample} title={currentTitle} data={currentModalData} />
    </>
  );
}

export default reduxForm<any, any>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: 'proposal',
  onSubmitFail: focusInputOnError,
  validate,
})(DpsForm);
